import React, { FC, useState } from 'react';
import Image from 'next/image';
import Box from '@/components/UI/box/Box';
import Icon from '@/components/UI/icon/Icon';
import Typography from '@/components/UI/typography/Typography';
import Drawer from '@/components/UI/drawer/Drawer';
import Modal from '@/components/UI/modal/Modal';
import GalleryItem from './galleryItem/GalleryItem';
import TopSliderGalleryFullHeightDesktop from '../topSliderGalleryFullHeightDesktop/TopSliderGalleryFullHeightDesktop';
import ShareModal from '../shareModal/ShareModal';
import useDrawer from '@/hooks/useDrawer';
import styles from './TopSlider.module.scss';
import { ProductItemTypes } from '../../_types/productItem.types';
type TopSliderProps = {
  productState: ProductItemTypes;
};
const TopSlider: FC<TopSliderProps> = ({
  productState
}) => {
  const {
    drawerOpen,
    drawerClose,
    isDrawerOpen
  } = useDrawer();
  const images = productState?.pictures?.records || [];
  const [clickedIndex, setClickedIndex] = useState<number>(0);
  const [first, second, third, fourth, fifth] = images;
  return <Box component={'section'} id="images" className={styles['top-slider']} onClick={() => drawerOpen('GALLERY')} data-sentry-element="Box" data-sentry-component="TopSlider" data-sentry-source-file="TopSlider.tsx">
      <Box component={'figure'} className={styles['top-slider-main']} data-sentry-element="Box" data-sentry-source-file="TopSlider.tsx">
        <Image layout="fill" objectFit="cover" src={first?.path || first?.hq_thumbnail_path || first?.thumbnail_path} alt={first?.title || first?.caption as string} title={first?.title} priority data-sentry-element="Image" data-sentry-source-file="TopSlider.tsx" />
      </Box>

      <Box className={styles['top-slider-others']} data-sentry-element="Box" data-sentry-source-file="TopSlider.tsx">
        <Box className={styles['top-slider-others-section']} data-sentry-element="Box" data-sentry-source-file="TopSlider.tsx">
          <GalleryItem item={second} onClick={() => setClickedIndex(1)} data-sentry-element="GalleryItem" data-sentry-source-file="TopSlider.tsx" />
          <GalleryItem item={third} onClick={() => setClickedIndex(2)} data-sentry-element="GalleryItem" data-sentry-source-file="TopSlider.tsx" />
        </Box>

        <Box className={styles['top-slider-others-section']} data-sentry-element="Box" data-sentry-source-file="TopSlider.tsx">
          <GalleryItem item={fourth} onClick={() => setClickedIndex(3)} data-sentry-element="GalleryItem" data-sentry-source-file="TopSlider.tsx" />
          <Box className={styles['top-slider-others-section-layer']} data-sentry-element="Box" data-sentry-source-file="TopSlider.tsx">
            <GalleryItem item={fifth} onClick={() => setClickedIndex(0)} data-sentry-element="GalleryItem" data-sentry-source-file="TopSlider.tsx" />
            <Box className={styles['top-slider-others-section-layer-backdrop']} data-sentry-element="Box" data-sentry-source-file="TopSlider.tsx">
              <Typography variant="bodyS" color="neutral_min" data-sentry-element="Typography" data-sentry-source-file="TopSlider.tsx">
                مشاهده تمام تصاویر
              </Typography>
              <Icon name="arrow-left-1" type="white" size={'small'} data-sentry-element="Icon" data-sentry-source-file="TopSlider.tsx" />
            </Box>
          </Box>
        </Box>
      </Box>

      <Drawer open={isDrawerOpen('GALLERY')} onClose={drawerClose} fullHeight data-sentry-element="Drawer" data-sentry-source-file="TopSlider.tsx">
        <TopSliderGalleryFullHeightDesktop handleClose={drawerClose} list={images} clickedIndex={clickedIndex} title={productState?.title as string} id={productState?.id as string | number} setIsShareOpen={drawerOpen} data-sentry-element="TopSliderGalleryFullHeightDesktop" data-sentry-source-file="TopSlider.tsx" />
      </Drawer>
      <Modal open={isDrawerOpen('SHARE')} onClose={drawerClose} data-sentry-element="Modal" data-sentry-source-file="TopSlider.tsx">
        <ShareModal handleClose={drawerClose} data-sentry-element="ShareModal" data-sentry-source-file="TopSlider.tsx" />
      </Modal>
    </Box>;
};
export default TopSlider;